<!-- overlay -->
<app-alert></app-alert>
<div class="d-flex">
  <div id="sidebar-overlay" class="overlay w-100   position-fixed " [ngClass]="overlayToShow"
    (click)="shoHideOverlay()"></div>

  <div class="px-0 main-container">
    <!-- top nav -->
    <nav class="top-nav w-100 d-flex justify-content-between px-4 py-2 " *ngIf="isAuthenticated">
      <div class="d-flex align-items-center gap-2">
        <button class="btn py-0" id="open-sidebar" (click)="shoHideMenu()">
          <i class="fa-solid fa-bars"></i>
        </button>
        <div class="div_logo cursor-pointer">
          <img src="safe-street.svg" style="height: 30px; width: auto;" routerLink="/">
        </div>
      </div>
      <div class="dropdown ml-auto d-flex" style="z-index: 1021;">
        <button class="btn py-0 d-flex align-items-center " id="logout-dropdown" data-bs-toggle="dropdown"
          aria-expanded="false">
          <i class="fa-solid fa-user"></i>
          <i class="fa-solid fa-chevron-down  ms-2  small"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-right border-0 shadow-sm" aria-labelledby="logout-dropdown">
          <li><a class="dropdown-item" routerLink="/my-profile">Profilo</a></li>
          <a class="dropdown-item" (click)="logout()">Logout</a>
        </div>
      </div>
    </nav>
    <div class="d-flex">
      <!-- sidebar -->
      <div *ngIf="isAuthenticated" class=" shadow-sm sidebar" [ngClass]="sideToShow" id="sidebar">
        <div class="list-group rounded-0" id="menu">
          <a (click)="openDashboard()" class="list-group-item list-group-item-action border-0 d-flex align-items-center"
            [ngClass]="currentMenu === ''? 'menu_active' : ''">
            <i class="fa-solid fa-table-columns"></i>
            <span>Dashboard</span>
            <i class="fa-solid fa-arrow-right arrow-active" [ngClass]="currentMenu === ''? '' : 'd-none'"></i>
          </a>
          @for (menu of menu; track $index) {
          @if (menu.childMenus != null&& menu.childMenus.length>0) {
          <button
            class="list-group-item list-group-item-action border-0 d-flex justify-content-between align-items-center collapsed"
            data-bs-toggle="collapse" [attr.data-bs-target]="'#sale-collapse'+menu.name">
            <div>
              <i class="{{menu.icon}}"></i>
              <span class="ml-2">{{menu.description}}</span>
              <i class="fa-solid fa-angle-down"></i>
            </div>
          </button>
          <div class="collapse" [id]="'sale-collapse'+menu.name" data-bs-parent="#sidebar">
            <div class="list-group position-relative">
              @for (sub_menu of menu.childMenus ; track $index) {
              <span class="v-line" [ngClass]="$index===menu.childMenus.length-1? 'v-line--end' : ''"></span>

              <a (click)="openMenu(sub_menu)" class="inner-menu list-group-item"
                [ngClass]="currentMenu === sub_menu.name? 'menu_active' : ''">
                <i class="{{sub_menu.icon}}"></i>
                {{sub_menu.description}}
                <i class="fa-solid fa-arrow-right arrow-active"
                  [ngClass]="currentMenu === sub_menu.name? '' : 'd-none'"></i>
              </a>

              }
            </div>
          </div>
          }
          @else {
          <a (click)="openMenu(menu)"  class="list-group-item list-group-item-action border-0 align-items-center "
            [ngClass]="currentMenu === menu.name? 'menu_active' : ''">
            <span class="bi bi-box"></span>
              <i class="{{menu.icon}}"></i>
            <span class="ml-2"  >{{menu.description}}</span>
          </a>
          }
          }
        </div>
      </div>
      <!-- main content -->
      <main class="main-content w-100 px-2">
        <div class="d-flex justify-content-center align-items-center">
          <div class="p-3 container  "
            [ngClass]="isAuthenticated? 'jumbotron jumbotron-fluid rounded bg-white border-0 shadow-sm':''">
            <router-outlet />
          </div>
        </div>


      </main>
    </div>
    <div class="footer-container">
      <p class="p-0 m-0">© 2025 - Tesisitaly S.R.L</p>
    </div>
  </div>
</div>
<div class="ps-fullloader" *ngIf="loading">
  <div class="loading-container">
    <span>
      {{loadingMessage}}
    </span>
    <div class="loading-wrapper">
      <div class="loader"></div>
    </div>
  </div>

</div>